import { render } from "./AclRulesTab.vue?vue&type=template&id=06b2a8a9&scoped=true"
import script from "./AclRulesTab.vue?vue&type=script&lang=js"
export * from "./AclRulesTab.vue?vue&type=script&lang=js"

import "./AclRulesTab.vue?vue&type=style&index=0&id=06b2a8a9&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b2a8a9"]])

export default __exports__